<ng-template #manageCollabs>
  <gc-manage-collaborators *ngIf="allowCollaboration && applicationId"
    [applicationId]="applicationId"
    [clientId]="clientId"
    [clientName]="clientName"
    [forNomination]="forNomination"
    [numberOfApplicants]="collaborators?.length || 1"
    [updateApplicationViewMap]="updateApplicationViewMap">
  </gc-manage-collaborators>
</ng-template>

<div class="d-flex flex-column applicant-panel"
  [class.slim]="slim">

  <div class="d-flex align-items-center justify-content-between mb-3"
    [class.slim-margin-bottom]="slim">
    <!-- Header -->
    <h2 [ngClass]="{'open': expandApplicantContainer}"
      class="applicant-header">
      <yc-i18n *ngIf="!forNomination"
        key="common:textApplicantInformation"
        defaultValue="Applicant Information">
      </yc-i18n>
      <yc-i18n *ngIf="forNomination"
        key="GLOBAL:textNominationInformation"
        defaultValue="Nomination Information">
      </yc-i18n>
    </h2>

    <!-- Non-mobile Manage Collaborators -->
    <div class="d-none d-md-flex align-items-center">
      <ng-template *ngTemplateOutlet="manageCollabs"></ng-template>
      <yc-button
        [icon]="true"
        [includeExpandedAria]="true"
        [ariaExpanded]="expandApplicantContainer"
        [tooltipText]="expandApplicantContainer ?
          ('common:textClose' | ycI18n: 'Close') :
          ('GLOBAL:textOpen' | ycI18n: 'Open')"
        [fontAwesomeIcon]="expandApplicantContainer ?
          'chevron-up' :
          'chevron-down'"
        (onClick)="expandApplicantContainer = !expandApplicantContainer">
      </yc-button>
    </div>
  </div>

  <div class="row applicant-container"
    [ngClass]="{'open': expandApplicantContainer}">
    <!-- Organization -->
    <div *ngIf="organization" 
      class="col-md-6 mb-2">
      <yc-nonprofit-block-display
        [name]="organization.name"
        [actionButtonText]="organization.canUpdate ?
          ('APPLY:textUpdateOrganization' | ycI18n: 'Update organization') :
          null"
        [actionButtonIsLink]="true"
        [addressString]="organization.addressString ||
          (organization.address | address: true)"
        [ein]="organization.identification"
        [isPrivateOrg]="organization.isPrivateOrg"
        [img]="{
          iconURL: organization.image
        } | getOrgIcon"
        [nameIsLink]="organization.nameIsLink"
        [openNameInNewTab]="organization.openNameInNewTab"
        [nameRouterLink]="routerLinkForNonprofit"
        [summaryNumbers]="nonprofitDetail?.summary ? {
          awardsPaidAmount: nonprofitDetail.summary.awardsPaidAmount,
          numberOfApplications: nonprofitDetail.summary.numberOfApplications,
          numberOfNominations: nonprofitDetail.summary.numberOfNominations,
          pendingPaymentsAmount: nonprofitDetail.summary.pendingPaymentsAmount,
          totalAwardAmount: nonprofitDetail.summary.totalAwardAmount
        } : undefined"
        [parentName]="organization.parentName"
        [parentRouterLink]="isManager && organization.parentGuid ?
          '/management/nonprofit/' + organization.parentGuid + '/profile' :
          ''"
        [hasNominations]="hasNominations"
        [currencyForStats]="defaultCurrency"
        (onActionClick)="onUpdateOrg.emit()"
        (onNameClick)="onOrgClick.emit()"> 
      </yc-nonprofit-block-display>
    </div>

    <!-- Applicants -->
    <!-- Primary applicant -->
    <ng-container *ngIf="applicant">
      <div class="col-md-6 mb-2">
        <gc-applicant-block
          [isMasked]="isMasked"
          [showMaskedToggle]="false"
          [name]="isMasked ? 
            applicantMaskedText : 
            (applicant.firstName + ' ' + applicant.lastName)"
          [email]="isMasked ? '' : applicant.email"
          [phone]="isMasked ? '' : applicant.phoneNumber"
          [addressString]="isMasked ? '' : applicant.addressString"
          [initials]="isMasked ?
            '' :
            applicant.firstName[0] + applicant.lastName[0]"
          [routerLinkForName]="isMasked ? '' : applicant.routerLink"
          [summaryNumbers]="applicant.isApplicationOwner ? 
            applicantDetail?.additionalData :
            undefined">
        </gc-applicant-block>
      </div>
    </ng-container>
    <!-- Collaborators -->
    <ng-container *ngIf="collaborators">
      <div class="col-md-6 mb-2"
        *ngFor="let collaborator of collaborators">
        <gc-applicant-block
          [isMasked]="isMasked"
          [showMaskedToggle]="false"
          [name]="isMasked ?
            applicantMaskedText :
            (collaborator.firstName + ' ' + collaborator.lastName)"
          [email]="isMasked ? '' : collaborator.email"
          [phone]="isMasked ? '' : collaborator.phoneNumber"
          [addressString]="collaborator.addressString"
          [initials]="isMasked ?
            '' :
            collaborator.firstName[0] + collaborator.lastName[0]"
          [routerLinkForName]="isMasked ? '' : collaborator.routerLink"
          [summaryNumbers]="collaborator.isApplicationOwner ? 
            applicantDetail?.additionalData :
            undefined">
        </gc-applicant-block>
      </div>
    </ng-container>
  </div>

  <!-- Mobile Manage Collabs-->
  <div class="d-flex d-md-none">
    <ng-template *ngTemplateOutlet="manageCollabs"></ng-template>
  </div>

</div>